export default defineNuxtPlugin(() => {
  const env = import.meta.env.VITE_APP_ENV
  if (env !== 'prod' && env !== 'rc') {
    import('eruda').then(eruda => eruda.default.init())
  }
})
